export default "__VITE_ASSET__BnjKKMca__"